import { Col, Container, Form, InputGroup, Row } from 'react-bootstrap'
import favicon from '../Utils/assets/img/pugcrm_logo1.png';
import logo from '../Utils/assets/img/pugcrm_logo_Fevicon.png';
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod"
import { useForm } from 'react-hook-form';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'sonner';
import { PostRequest } from '../Utils/hooks/ApiHandler';
import useLocalStorageState from 'use-local-storage-state';
import { useEffect, useState } from 'react';
import '../Utils/assets/css/login.css';
import google from "../Utils/assets/img/google.svg"
import { baseURL } from '../Utils/constants/constant';
import { FaEye, FaEyeSlash } from "react-icons/fa";
import axios from 'axios';
//  Device detection imports
import {
    isMobile,
    isTablet,
    osName,
    browserName,
    mobileModel
} from 'react-device-detect';
import { Permission } from '../Utils/helpers/Permission';
import { getIp } from '../Utils/helpers/commonhelper';


const loginSchema = z.object({
    email: z.string().email().min(1, "Email is Required"),
    password: z.string().min(6, "Password length must be of 6 characters")
})
export const Login = () => {

    const location = useLocation();

    //  Detect device info on mount
    // useEffect(() => {
    //     const deviceInfo = {
    //         device: isMobile ? 'Mobile' : isTablet ? 'Tablet' : 'Desktop',
    //         os: osName,
    //         browser: browserName,
    //         model: isMobile ? mobileModel : 'N/A'
    //     };

    // }, []);


    const [showPassword, setShowPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(false)

    // form methods destructuring
    const { handleSubmit, register, formState: { errors, isValid, } } = useForm({
        resolver: zodResolver(loginSchema)
    })

    const navigate = useNavigate()

    // const getIp = async () => {
    //     const res = await axios.get("https://api.ipify.org?format=json");
    //     if (res?.status === 200) {
    //         return res?.data?.ip
    //     }
    // }
    // customerid state for sessionstorage
    const [customer, setCustomer] = useLocalStorageState("customer", {
        customer_details: {},
        token: {},
        user_login: false,
        customer_status: "Inactive"
    })
    const [PERMISSION, setPermission] = useLocalStorageState('permission')
    const [lastPath] = useLocalStorageState("lastPath");
    useEffect(() => {
        if (customer && customer?.user_login === true && customer?.customer_status === "Active") {
            navigate(lastPath, { replace: true });
        }
        return () => { }
    }, [lastPath]);
    // handle form submit
    const handleFormSubmit = async (formdata) => {
        // const userIp = await getIp();

        const payload = {
            ...formdata,
            device: isMobile ? 'Mobile' : 'Desktop',
            os: osName,
            browser: browserName,
            model: isMobile ? mobileModel : 'N/A',
            ip: 'userIp'
        }
        setIsLoading(true)
        try {
            if (!isValid) return
            const res = await PostRequest("/auth/login", payload, false, {}, {})
            if (res.status === "fail") {
                toast.warning(res.message)
                setIsLoading(false)
                return
            }

            setCustomer((prev) => ({ ...prev, isRegistered: res?.data[0]?.isRegistered?.toLowerCase() === "register" ? true : false, user_login: true, customer_details: res.data[0], token: res.token, customer_status: res.data[0].status }))
            const permissionObj = Permission(res.data[0]?.permission, res.data[0]?.user_type)
            setPermission(permissionObj)
            navigate("/dashboard", { replace: true })
            toast.success(`Welcome back ${res.data[0].first_name} ${res.data[0].last_name} !`)
            setIsLoading(false)
            return
        }
        catch (error) {

            toast.error("Internal Server Error")
            setIsLoading(false)
            return
        }
    }



    return (
        <Container fluid className="  p-0" style={{ fontFamily: "'Poppins', sans-serif" }}>
            <Row className="overflow-hidden bg-white w-100 pe-2 m-0 mainDivs" style={{ height: 'calc(100vh - 0rem)', padding: '30px 0px' }}>

                <div className="BaseBox col-md-8 ps-8">
                    {/* <div className="logoImgDivs" style={Styles.logoImgDivs}>
                        
                    </div> */}
                    <div>
                        <div className="BaseBox-inner">

                            <h3 className="StyledBaseText" ><span className="StyledBaseText" >India's No 1</span> Choice for Smarter Selling Simplest and Secure CRM Technology.</h3>

                        </div>
                        <div className="BaseBox-second">
                            <div className="BaseBox-second-inner">
                                <div className="BaseBox-second-inner-icon">
                                    <i className="fa fa-star"></i>
                                </div>
                                <h6 className="StyledBaseText">Automated Lead <span style={{ fontSize: '1rem', lineHeight: 1.5 }}>Distribution</span></h6>
                            </div>
                            <div className="BaseBox-second-inner">
                                <div className="BaseBox-second-inner-icon">
                                    <i className="fa fa-user-tie"></i>
                                </div>
                                <h6 className="StyledBaseText">Sales Analytics & <span style={{ fontSize: '1rem', lineHeight: 1.5 }}>Forcasting</span></h6></div>
                            <div className="BaseBox-second-inner">
                                <div className="BaseBox-second-inner-icon">
                                    <i className="fa fa-briefcase"></i>
                                </div>
                                <h6 className="StyledBaseText">Social Media <span style={{ fontSize: '1rem', lineHeight: 1.5 }}>Integration</span></h6>
                            </div>
                            <div className="BaseBox-second-inner">
                                <div className="BaseBox-second-inner-icon">
                                    <i className="fa fa-earth-asia"></i>
                                </div>
                                <h6 className="StyledBaseText">Analytics <span style={{ fontSize: '1rem', lineHeight: 1.5 }}>Dashboard</span></h6>
                            </div>
                        </div>
                    </div>

                </div>

                {/* Right Panel - Registration Form */}
                <Col md={4} className="py-0 h-100 col-md-4 pe-4 p-0">
                    <div className="formDiv w-100 h-100 py-5 px-3">
                        <div className='innerFormDiv w-100'>
                            <div className="text-start ps-4 mb-4">
                                <img
                                    src={favicon}
                                    alt="Logo"
                                    className='favicon'
                                />

                                <p className="fw-bold bigHeading mt-5" style={{ color: 'black', fontSize: 28, lineHeight: 1.3 }}>Welcome to PugCRM! </p>
                                <p className="smallHeading mt-3" style={{ fontSize: 14, marginTop: 14, fontWeight: 400, letterSpacing: 0 }}>Enter your login details to continue</p>

                            </div>

                            <Form onSubmit={handleSubmit(handleFormSubmit)} style={{ textAlign: 'justify', padding: '0px 25px', }}>
                                {/* email */}
                                <Form.Group className="mb-3" controlId="formEmail">
                                    <Form.Label>Email Address</Form.Label>
                                    <InputGroup>
                                        <Form.Control className='loginInput'
                                            type="email"
                                            {...register("email", {
                                                required: true
                                            })}
                                            placeholder="Email Address"
                                        />
                                    </InputGroup>
                                    {errors.email && <p style={{ fontSize: '11px' }} className='text-danger mt-0'>{errors.email.message}</p>}
                                </Form.Group>
                                {/* password */}
                                <Form.Group controlId="formPassword">
                                    <Form.Label>Password</Form.Label>
                                    <InputGroup>
                                        <Form.Control className='loginInput'
                                            type={showPassword ? "text" : "password"}
                                            {...register("password", {
                                                required: true
                                            })}
                                            placeholder="Enter Password"
                                        />
                                        <span
                                            onClick={() => setShowPassword((prev) => !prev)}
                                            style={{
                                                position: "absolute",
                                                right: "2%",
                                                top: "12%",
                                                zIndex: 6,
                                                padding: "2px",
                                                cursor: "pointer",
                                            }}
                                        > {showPassword ? <FaEyeSlash /> : <FaEye />} </span>
                                    </InputGroup>
                                    <div className='row mt-2' style={{ marginBottom: '8%' }}>
                                        {errors.password && <p style={{ fontSize: "11px" }} className='text-danger mt-0 col-md-12'>{errors.password.message}</p>}
                                        <p style={{ width: '100%', cursor: 'pointer', fontSize: '12px', textAlign: 'end', marginTop: '3px' }} className='text-primary col-md-6' onClick={() => navigate("/forgot-password")} >Forgot Password?</p>

                                    </div>

                                </Form.Group>
                                {/* buttons */}
                                <div className='w-100 d-flex flex-column gap-2 justify-content-center'>
                                    {/* login */}
                                    <button style={{ backgroundColor: "#7a3a5e", color: 'white', border: 0 }} type="submit" className="w-50 align-self-center py-2 fw-medium  rounded-2" disabled={isLoading}>
                                        {isLoading ? <><div className="spinner-border spinner-border-sm me-1" role="status" />Login</> : "Login"}

                                    </button>
                                    {/* google login */}
                                    <button onClick={() => window.open(`${baseURL}/auth/Google`, "_self")} style={{ color: 'white', backgroundColor: "#7a3a5e", border: "none" }} className="w-50 py-2 fw-medium rounded-2 align-self-center" type='button' disabled={isLoading}>
                                        Google Login <img style={{ width: "24px", height: '24px', borderRadius: '20px' }} src={google} alt="googlesvg" />
                                    </button>

                                    <div className='mt-2 text-center'>
                                        <p> <span className='font-weight-bold text-secondary ' style={{ fontSize: '12px' }}>Don't have an account? </span><span style={{ cursor: 'pointer', fontSize: '13px' }} className='text-primary ' onClick={() => navigate('/register')}>Register Now</span></p>
                                    </div>
                                </div><s></s>
                            </Form>
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>
    )
}


const Styles = {
    logoImgDivs: {
        background: `URL(${logo})`,



    }
}